import { ModifiersUtils, RangeModifier } from 'react-day-picker';

const isDayExcluded = (day: Date, exclusions: RangeModifier[]) =>
  ModifiersUtils.dayMatchesModifier(day, exclusions);

export default isDayExcluded;
